<template>
  <div id="ag-grid-demo">
    <vx-card>
      <data-table
        :column-defs="columnDefs"
        :default-col-def="defaultColDef"
        :row-data="keywords"
        :grid-options="gridOptions"
        pagination
      >
        <template #actions>
          <vs-button
            @click="onClickDownload"
          >
            結果エクスポート
          </vs-button>
          <vs-button
            class="ml-4"
            @click="onClickRegister"
          >
            登録
          </vs-button>
        </template>
      </data-table>
    </vx-card>
    <form-modal
      v-model="showForm"
      title="キーワード登録"
      @click:submit="onClickSubmit"
    >
      <template #content>
        <ValidationForm ref="keywordObserver">
          <monitoring-keyword-form
            v-model:asin="asin"
            v-model:keyword="keyword"
          />
        </ValidationForm>
      </template>
    </form-modal>
    <confirm-modal
      v-model="showConfirmModal"
      @click:confirm="onClickConfirm"
      @click:cancel="showConfirmModal = false"
    >
      <template #content>
        <p class="p-4 whitespace-pre-wrap">
          {{ `ASIN: ${asin} キーワード: ${keyword}` }} を本当に削除しますか？
        </p>
      </template>
    </confirm-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataTable from '@/components/table/DataTable'
import FormModal from '@/components/modals/FormModal'
import DataTableCellSwitch from '@/components/table/DataTableCellSwitch'
import DataTableCellTrash from '@/components/table/DataTableCellTrash'
import ConfirmModal from '@/components/modals/ConfirmModal'
import MonitoringKeywordForm from '@/components/forms/MonitoringKeywordForm'

export default {
  name: 'Keyword',
  components: {
    MonitoringKeywordForm,
    ConfirmModal,
    FormModal,
    DataTable
  },
  data () {
    return {
      pageSize: 20,
      defaultColDef: {
        sortable: false,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ASIN',
          field: 'asin'
        },
        {
          headerName: 'キーワード',
          field: 'keyword'
        },
        {
          headerName: '有効／無効',
          field: 'enabled',
          cellRenderer: 'dataTableCellSwitch',
          cellRendererParams : {
            action : this.checkBoxAction.bind(this)
          }
        },
        {
          headerName: '',
          field: 'deleted',
          cellRenderer: 'dataTableCellTrash',
          cellRendererParams : {
            action : this.trashAction.bind(this)
          }
        }
      ],
      gridOptions: {},
      id: null,
      asin: null,
      keyword: null,
      showForm: false,
      showConfirmModal: false,
      confirmMessage: null
    }
  },
  computed: {
    ...mapState('monitoring', ['keywords'])
  },
  watch: {
    showForm (value) {
      if (!value) {
        this.$nextTick(function () {
          this.resetKeyword()
          // this.resetKeyword()でキーワードとかnullにするとvee-validateのエラーが反応してしまうのでリセットする
          requestAnimationFrame(() => {
            this.$refs.keywordObserver.resetForm()
          })
        })
      }
    },
    showConfirmModal (value) {
      if (!value) {
        this.$nextTick(function () {
          window.setTimeout(() => {
            this.resetKeyword()
          }, 300)
        })
      }
    }
  },
  beforeMount () {
    this.gridOptions = {
      autoSizeStrategy: {
        type: 'fitGridWidth',
        defaultMinWidth: 150,
        columnLimits: [{
          colId: 'asin',
          maxWidth: 150
        },{
          colId: 'enabled',
          maxWidth: 150
        },{
          colId: 'deleted',
          maxWidth: 150
        }]
      },
      components: {
        dataTableCellSwitch: DataTableCellSwitch,
        dataTableCellTrash: DataTableCellTrash
      }
    }
  },
  async mounted () {
    await this.listKeywords()
  },
  methods: {
    ...mapActions('monitoring', [
      'listKeywords',
      'addKeyword',
      'updateKeyword',
      'deleteKeyword',
      'downloadKeywordsCSV'
    ]),
    async onClickDownload () {
      try {
        await this.downloadKeywordsCSV()
      } catch (e) {
        console.log(e)
      }
    },
    onClickRegister () {
      this.showForm = true
    },
    async checkBoxAction ({ index, value }) {
      await this.updateKeyword({
        ...this.keywords[index],
        enabled: value
      })
    },
    trashAction ({ index }) {
      const targetKeyword = this.keywords[index]
      this.id = targetKeyword.id
      this.keyword = targetKeyword.keyword
      this.asin = targetKeyword.asin
      this.showConfirmModal = true
    },
    resetKeyword () {
      this.id = null
      this.keyword = null
      this.asin = null
    },
    async onClickConfirm () {
      try {
        await this.deleteKeyword({
          id: this.id
        })
        this.showConfirmModal = false
      } catch (e) {
        console.log(e)
      }
    },
    async onClickSubmit () {
      const isValid = await this.$refs.keywordObserver.validate()
      if (!isValid.valid) return
      try {
        await this.addKeyword({
          asin: this.asin,
          keyword: this.keyword,
          enabled: 1
        })
        this.showForm = false
      } catch (e) {
        console.log(e)
      }
    }
  }
}

</script>

<style>

</style>
